import {$host} from "@/services/index";

export const fetchServerStatus = async () => {
    const { data } = await $host.post('server-status/')
    return data
}